import { useTranslation } from '@/context/TranslationContext';
import styles from './Hero.module.scss';

export default function Hero() {
    const { t } = useTranslation();

    return (
        <section id="hero" className={styles.hero}>
            <div className={styles.backgroundAnimation}></div>
            <div className={styles.container}>
                <div className={styles.content} data-aos="fade-up" data-aos-duration="1000">
                    <h2 className={styles.greeting}>{t('HERO.GREETING')}</h2>
                    <h1 className={styles.name}>Berkin Koray</h1>
                    <h3 className={styles.title}>{t('HERO.TITLE')}</h3>
                    <p className={styles.description}>
                        {t('HERO.DESCRIPTION')}
                    </p>
                    <div className={styles.ctaButtons}>
                        <a href="#contact" className={`${styles.btn} ${styles.primary}`}>{t('HERO.CTA.QUOTE')}</a>
                        {/* TODO: In Zukunft soll dieser Link zu #projects scrollen */}
                        <a
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                const subject = encodeURIComponent('Erfolgsgeschichten anfragen');
                                const body = encodeURIComponent(
                                    'Hallo,\n\nich habe Interesse an Ihren Dienstleistungen und würde gerne die bereits umgesetzten Projekte sehen.\n\nBitte kontaktieren Sie mich.\n\nVielen Dank!'
                                );
                                window.location.href = `mailto:kontakt@koricode.de?subject=${subject}&body=${body}`;
                            }}
                            className={`${styles.btn} ${styles.secondary}`}
                        >
                            {t('HERO.CTA.WORK')}
                        </a>
                    </div>
                </div>
            </div>
            <div className={styles.visual} data-aos="fade-left" data-aos-duration="1000" data-aos-delay="200">
                <div className={styles.profileGlow}>
                    <div className={styles.circle}></div>
                </div>
            </div>

            <div className={styles.scrollDown}>
                <i className='bx bx-chevron-down'></i>
            </div>
        </section>
    );
}
